import { Link } from 'react-router-dom';
import { ArrowLeft, Image, Tag } from 'lucide-react';
import ArtifactGallery from './ArtifactGallery.jsx';
import DocumentText from './DocumentText.jsx';
import PostcardPlaceNotes from './PostcardPlaceNotes.jsx';

export default function PostcardDetail({ book, mediaRevision, catalogUrl }) {
  return <section className="postcard-detail container">
    <Link to={catalogUrl || '/?itemType=postcard'} className="back-link"><ArrowLeft size={17}/> Înapoi la catalog</Link>
    <header className="postcard-title"><div><span className="overline">Colecția de cărți poștale</span><h1>{book.title}</h1></div><span className="postcard-reference"><Image size={19}/>{book.identifier}</span></header>
    <ArtifactGallery key={book.id} book={book} mediaRevision={mediaRevision}/>
    <div className="postcard-notes">
      <PostcardPlaceNotes book={book}/>
      {book.description && <p className="book-description">{book.description}</p>}
      {book.tags.length > 0 && <div className="detail-tags"><Tag size={17}/>{book.tags.map((tag) => <span key={tag}>{tag}</span>)}</div>}
      <DocumentText key={book.id} book={book}/>
    </div>
  </section>;
}
